import React from 'react'

const Manual_admin_abono_cuenta_personal_clientes = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Admin - Abono a Cuenta Personal Clientes
        </h2>
        <iframe
          src="https://scribehow.com/embed/Admin__Abono_a_Cuenta_Personal_Clientes__chA_tfGQRXCJby3QRRtzWA?as=scrollable"
          className="scribe-iframe-general-172"
          width="100%"
          height="4700"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_admin_abono_cuenta_personal_clientes
